import React from 'react';
import {
    Link,
    withRouter
} from 'react-router-dom';
import constants from '../ndbk-constants'
// import {socketConnect} from 'socket.io-react'
import Search from './Search'
import { AnchorButton } from '@blueprintjs/core';
// import { connect } from 'react-redux'

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            notifications: 0,
            messages: 0,
            recentNodebooks: []
        }
    }
    fetchNotifications = () => {
        // fetch(`https://${constants.SERVER_IP}/api/notifications/unseen`, {
        //     method: 'GET',
        //     credentials: 'include',
        // })
        //     .then((response) => response.json())
        //     .then((response) => {
        //         if (response.success) {
        //             this.props.setNotifications(response.data.notifications)
        //         }
        //         return response.success
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //     });
    }
    fetchRecentNodebooks = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebooks/recent`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ recentNodebooks: response.data.slice(0, 8) })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchMessages = () => {
        fetch(`https://${constants.SERVER_IP}/api/messages/unseen`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.props.setMessages(response.data.messages)
                }
                return response.success
            })
            .catch((error) => {
                console.error(error);
            });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ messages: nextProps.messages, notifications: nextProps.notifications })
    }

    componentDidMount() {
        if (this.props.auth.user.isGuest === true) {
            return
        }
        // this.fetchNotifications();
        // this.fetchMessages();
        this.fetchRecentNodebooks()

        // this.props.socket.on('new notification', (args) => {
        //     this.props.incrementNotifications();
        // })

        // this.props.socket.on('new message', (args) => {
        //     this.props.incrementMessages();
        // })
    }

    componentWillUnmount() {
        if (this.props.auth.user.isGuest) {
            return
        }

        // this.props.socket.off('new notification')
        // this.props.socket.off('new message')
    }

    mobileHeaderShow = () => {
        document.getElementsByClassName('header')[0].classList.add('mobile')
        if (document.getElementsByClassName('main').length > 0) {
            document.getElementsByClassName('main')[0].classList.add('mobile')
        }
        this.mobileHeaderShowBtn.classList.remove('active')
        this.mobileHeaderHideBtn.classList.add('active')
    }

    mobileHeaderHide = () => {
        document.getElementsByClassName('header')[0].classList.remove('mobile')
        if (document.getElementsByClassName('main').length > 0) {
            document.getElementsByClassName('main')[0].classList.remove('mobile')
        }
        this.mobileHeaderHideBtn.classList.remove('active')
        this.mobileHeaderShowBtn.classList.add('active')
    }

    createNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook_create`,
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: 'New nodebook',
                    description: '',
                    visibility: 'public',
                    //templates: this.state.templates.filter((value, id)=>value.selected===true).map((value, id)=>value.id)
                })
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.props.history.push(`/nodebook/${response.data.id}`);
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    render() {

        let isPageMessages = (this.props.path === '/messages')
        let isPageNotifications = (this.props.path === '/notifications')
        // let isPageNewNodebook = (this.props.path==='/new/nodebook')

        return (
            <header className={"header" + (this.props.isNodebookPage ? ' ndbk' : '')}>
                <div className="header-logo">
                    <Link to={this.props.isNodebookPage ? "/" : "/landing"}>
                        <span>node</span>book
                    </Link>
                </div>

                <div className="header-background"></div>
                <div className="header-search-wrapper" style={{ display: "flex", alignItems: "center" }}>
                    <Search
                        isNodebookPage={this.props.isNodebookPage}
                        toggleSearchMode={this.props.toggleSearchMode}
                        nodebookExecuteSearch={this.props.nodebookExecuteSearch}
                        uberCreateNode={this.props.uberCreateNode}
                    />
                    {/* <div style={{ display: "inline-block", marginLeft: "20px" }}>
                        {
                            (this.props.auth.user.plan === 'premium' || this.props.auth.user.isGuest)
                                ? <AnchorButton href="https://nodebook.io/payment" text="Donate" minimal icon="bank-account" />
                                : <AnchorButton href="https://nodebook.io/payment" text="Become a premium member / donate" intent="success" icon="credit-card" />
                        }
                    </div> */}
                </div>

                <ul className="header-nav">
                    {
                        (this.state.recentNodebooks.length > 0)
                            ? (
                                <li>
                                    <a>
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                            <path fill="#666" d="M0 6c0-0.128 0.049-0.256 0.146-0.354 0.195-0.195 0.512-0.195 0.707 0l8.646 8.646 8.646-8.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-9 9c-0.195 0.195-0.512 0.195-0.707 0l-9-9c-0.098-0.098-0.146-0.226-0.146-0.354z"></path>
                                        </svg>
                                    </a>
                                    <ul className="recent">
                                        <li className="title">Recent nodebooks</li>
                                        <li className="separator"></li>
                                        {
                                            this.state.recentNodebooks.map(
                                                ndbk => <li key={ndbk.id}><Link title={ndbk.title} to={`/nodebook/${ndbk.id}`}>{ndbk.title}</Link></li>
                                            )
                                        }
                                    </ul>
                                </li>
                            )
                            : null
                    }
                    {
                        // (this.props.auth.user.isGuest)
                        //     ? null
                        //     : (
                        //         <li title="Notifications">
                        //             <Link tabIndex="-1" to="/notifications" className={isPageNotifications ? 'current' : ''}>
                        //                 {/*<span className="icon notification"></span>*/}
                        //                 <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        //                     <path fill="#666" d="M16.8 15.101c-1.144-0.859-1.8-2.172-1.8-3.601v-3c0-2.513-1.694-4.638-4-5.292l-0-0.708c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5v0.708c-2.306 0.655-4 2.779-4 5.292v3c0 1.429-0.656 2.741-1.8 3.601-0.172 0.129-0.242 0.354-0.174 0.558s0.259 0.342 0.474 0.342h4.55c-0.033 0.164-0.051 0.331-0.051 0.5 0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5c0-0.168-0.017-0.336-0.050-0.5h4.55c0.215 0 0.406-0.138 0.474-0.342s-0.002-0.429-0.174-0.558zM9 2.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.523c-0.165-0.015-0.331-0.023-0.5-0.023s-0.335 0.008-0.5 0.023v-0.523zM11 16.5c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5c0-0.171 0.030-0.34 0.086-0.5h2.828c0.056 0.16 0.086 0.329 0.086 0.5zM3.742 15c0.255-0.309 0.477-0.646 0.659-1.001 0.398-0.778 0.599-1.619 0.599-2.499v-3c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5v3c0 0.88 0.202 1.721 0.599 2.499 0.182 0.356 0.404 0.692 0.659 1.001h-11.517z"></path>
                        //                 </svg>
                        //                 {(this.state.notifications > 0) ? <span className="count">{/*this.state.notifications*/}</span> : null}
                        //             </Link>
                        //         </li>
                        //     )
                    }

                    {/* <li>
                        <Link to="/messages" className={isPageMessages?'current':''}>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                <path fill="#666" d="M17.5 6h-16c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h16c0.827 0 1.5-0.673 1.5-1.5v-9c0-0.827-0.673-1.5-1.5-1.5zM17.5 7c0.030 0 0.058 0.003 0.087 0.008l-7.532 5.021c-0.29 0.193-0.819 0.193-1.109 0l-7.532-5.021c0.028-0.005 0.057-0.008 0.087-0.008h16zM17.5 17h-16c-0.276 0-0.5-0.224-0.5-0.5v-8.566l7.391 4.927c0.311 0.207 0.71 0.311 1.109 0.311s0.798-0.104 1.109-0.311l7.391-4.927v8.566c0 0.276-0.224 0.5-0.5 0.5z"></path>
                            </svg>
                            {(this.state.messages>0)?<span className="count">{this.state.messages}</span>:null}
                        </Link>
                    </li> */}

                    <li title="Create new nodebook">
                        <a onClick={this.props.auth.user.isGuest ? undefined : this.createNodebook}
                            href={this.props.auth.user.isGuest ? "/login" : undefined}
                        //className={isPageNewNodebook?'current':''}
                        >
                            {/*<span className="icon plus"></span>*/}
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                <path fill="#666" d="M16.218 3.782c-1.794-1.794-4.18-2.782-6.718-2.782s-4.923 0.988-6.718 2.782-2.782 4.18-2.782 6.717 0.988 4.923 2.782 6.718 4.18 2.782 6.718 2.782 4.923-0.988 6.718-2.782 2.782-4.18 2.782-6.718-0.988-4.923-2.782-6.717zM9.5 19c-4.687 0-8.5-3.813-8.5-8.5s3.813-8.5 8.5-8.5c4.687 0 8.5 3.813 8.5 8.5s-3.813 8.5-8.5 8.5z"></path>
                                <path fill="#666" d="M15.5 10h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"></path>
                            </svg>

                        </a>
                    </li>

                    <li className="nav-user">
                        <Link tabIndex="-1" className="nav-user-name" to={`/user/${this.props.auth.user.username}`}>
                            {this.props.auth.user.username}
                            <span className="avatar" style={{ backgroundImage: "url(" + this.props.auth.user.avatar + ")" }}></span>
                        </Link>
                        {/*<ul className="submenu">
                            <li onClick={()=>{this.props.history.push('/settings')}}>Settings</li>
                            <li onClick={()=>{this.props.history.push('/guide')}}>Help</li>
                            <li><LogoutButton {...this.props}/></li>
                        </ul>*/}
                    </li>
                </ul>
                <ul className="header-nav-mobile">
                    <li><Link to={`/dashboard`}>Dashboard</Link></li>
                    <li><Link to={`/nodebooks`}>Nodebooks</Link></li>
                    <li><Link to={`/groups`}>Groups</Link></li>
                    <li><Link to={`/organizations`}>Organizations</Link></li>
                    <li><Link to={`/notifications`}>Notifications</Link></li>
                    <li><Link to={`/messages`}>Messages</Link></li>
                    <li><Link to="/new/nodebook">New nodebook</Link></li>
                    <li><Link to="/nodebook/import">Import nodebook</Link></li>
                    <li><Link to="/new/group">New group</Link></li>
                    <li><Link to="/new/organization">New organization</Link></li>
                </ul>
                <a className="header-open active" onClick={this.mobileHeaderShow} ref={c => this.mobileHeaderShowBtn = c} href="#"></a>
                <a className="header-close" onClick={this.mobileHeaderHide} ref={c => this.mobileHeaderHideBtn = c} href="#"></a>
            </header>
        )
    }
}

function mapStateToProps(state) {
    return { messages: state.messages, notifications: state.notifications }
}

function mapDispatchToProps(dispatch) {
    return {
        incrementMessages: () => { dispatch({ type: 'INCREMENT_MESSAGES' }) },
        incrementNotifications: () => { dispatch({ type: 'INCREMENT_NOTIFICATIONS' }) },
        setNotifications: (count) => { dispatch({ type: 'SET_NOTIFICATIONS', count: count }) },
        setMessages: (count) => { dispatch({ type: 'SET_MESSAGES', count: count }) }
    }
}

export default withRouter(/* connect(mapStateToProps, mapDispatchToProps) */(Header))

//export default withRouter(socketConnect(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js